import formatDate from "@/features/dateTime/functions/formatDate";
import useForm from "@/layout/form/hooks/useForm";
import assetUrlGenerator from "@/features/images/functions/assetUrlGenerator";
import { useAppSelector } from "@/hooks/selector/useAppSelector";
import {defaultVehicleData} from "../../../constants/defaultVehicleData";

export const useDefaultVehicleSnippets = () => {
    const assetsBaseUrl = useAppSelector((state) => state?.page.assetsBaseUrl)
    const {date, fromId, toId, fromSlug, toSlug} = useForm("urlParams")
    const gbtHomepageUrl = useAppSelector((state) => state?.page.gbtUrl)
    const formattedDate = formatDate(date, 'dd-MM-yyyy')

    return defaultVehicleData.map(vehicle => ({
        ...vehicle,
        link: `${gbtHomepageUrl}/en/booking/${fromSlug}-${fromId}/${toSlug}-${toId}/${formattedDate}/${vehicle.maxNumberOfPassengers}`,
        imageUrl: assetUrlGenerator(assetsBaseUrl, vehicle.imageUrl),
    }));
};

export default useDefaultVehicleSnippets;
